<template>

    <Page class="text-lg !max-w-[80%]">

        <div>
            <h2 class="text-xl font-semibold">Earn More, Effortlessly</h2>
            <ul class="mt-1 list-disc text-white/60">
                <li class="pl-2 ml-5 mb-2 2xl:mb-4">
                    Carbucks PROTECT gives you a high-value add-on that customers actually want. 
                    More value means more sales opportunities — and more commission in your pocket.
                </li>
            </ul>

            <h2 class="mt-6 text-xl font-semibold">Stand Out as a Trusted Advisor</h2>
            <ul class="mt-1 list-disc text-white/60">
                <li class="pl-2 ml-5 mb-2 2xl:mb-4">
                    When you offer protection that genuinely helps with real-world problems 
                    (like tyres, batteries, and brakes), customers see you as someone who's 
                    looking out for them — not just selling to them.
                </li>
            </ul>

            <h2 class="mt-6 text-xl font-semibold">Sell with Confidence</h2>
            <ul class="mt-1 list-disc text-white/60">
                <li class="pl-2 ml-5 mb-2 2xl:mb-4">
                    Backed by full compliance, easy training, and a clear product structure, 
                    you can sell knowing you're fully supported and protected — 
                    no grey areas, no second guessing.
                </li>
            </ul>
        </div>

    </Page>

</template>